import { CircularProgress } from "@mui/material";
import LoaderStyles from "./Loader.module.scss";
import Typography from "../Typography/Typography";

const Loader = ({
  hideDescription = false,
  loaderText,
  loaderColor = "var(--primaryGreyColor)",
  textColor = "var(--primaryGreyColor)",
  secondaryText,
}: any) => {
  return (
    <div className={LoaderStyles.loader}>
      <CircularProgress
        size={20}
        style={{
          color: loaderColor,
        }}
      />
      <Typography
        color={textColor}
        fontSize={14}
        fontStyle="italic"
      >
        Loading...
      </Typography>
      {!hideDescription && <Typography color={textColor}>{loaderText}</Typography>}
      {secondaryText && (
        <Typography color={textColor} style={{ marginTop: 6 }}>
          {secondaryText}
        </Typography>
      )}
    </div>
  );
};

export default Loader;
